import Index from '@tunnel-components/@pages/incidents/home/container'

/**
 * @export Container
 */

export default Index;


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/incidents/home/index.ts